import * as React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
} from '@material-ui/core';
import { SubmitSnackbar } from '../../../components';
import { globalDateEntity } from '../../../constants/applicationConstants';

function Header() {

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            style={{
              cursor: 'pointer',
              alignSelf: 'center',
              color: globalDateEntity.primaryFontColor,
            }}
            noWrap
            onClick={() => props.history.push(`/`)}
          >
            {globalDateEntity.siteHeaderTitle}
          </Typography>          
        </Toolbar>
      </Container>
      <SubmitSnackbar />
    </AppBar>
  );
}
export default Header;
